import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { FN_IMAGE__get_best_first_tab_for_image_edit } from '@/utils/_methods/FN_IMAGE__get_best_first_tab_for_image_edit';
import { ENUM__page_generation_layout } from '../../../_enums/ENUM__page_generation_layout';
import { HOOK_FIELD_IMAGES__get_fields_to_render } from '../../../_hooks/HOOK_FIELD_IMAGES__get_fields_to_render';
import { FN_FIELD_IMAGE__edit } from '../../../sidebar/image_asset/_methods/FN_FIELD_IMAGE__edit';

export function WATCHER__image_edit_select_field() {
  /*
   * STORE
   */

  const { g_image_edit__field, g_general__layout, g_image_edit__tab } = use_slice_ui(['g_image_edit__field', 'g_general__layout', 'g_image_edit__tab']);
  const { fields_images_all } = HOOK_FIELD_IMAGES__get_fields_to_render();

  /*
   * EFFECTS
   */

  use_effect(() => {
    if (g_general__layout != ENUM__page_generation_layout.ASSETS) return; //no need to select field
    if (fields_images_all.is_empty()) return; //no fields to render
    if (fields_images_all.some(item => item.meta.field_id == g_image_edit__field.meta.field_id)) return; //field already selected from list

    let field_to_select = fields_images_all[0];

    let best_tab = FN_IMAGE__get_best_first_tab_for_image_edit(field_to_select);
    FN_FIELD_IMAGE__edit(field_to_select, g_general__layout, best_tab);
  }, [g_image_edit__field, g_general__layout, fields_images_all]);

  return null;
}
